import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { catchAsync } from 'helpers';

export const deletePassengersById = createAsyncThunk(
  'passengers/deletePassengersById',
  catchAsync(async (data, thunkAPI) => {
    const res = await axios.post('/passengers/delete', data);
    return res.data;
  })
);
